
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  OrganizationRole,
  OrganizationRoleUpdateRequest,
} from '../models';
import {
    OrganizationRoleFromJSON,
    OrganizationRoleToJSON,
    OrganizationRoleUpdateRequestFromJSON,
    OrganizationRoleUpdateRequestToJSON,
} from '../models';

export interface GetRoleRequest {
    organizationId: string;
    accountId: string;
}

export interface SetRoleRequest {
    organizationId: string;
    accountId: string;
    organizationRoleUpdateRequest: OrganizationRoleUpdateRequest;
}

/**
 * 
 */
export class OrganizationMemberDetailsApi extends runtime.BaseAPI {

    /**
     * Get the role of the specified member in the organization
          */
    async getRoleRaw(requestParameters: GetRoleRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<OrganizationRole>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getRole().'
            );
        }

        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling getRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<OrganizationRole>({
            path: `/client-settings/api/organizations/{organizationId}/member/{accountId}/role`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))).replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters['accountId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=OrganizationRoleFromJSON(response._data); }
        return response;
    }

    /**
     * Get the role of the specified member in the organization
          */
    async getRole(requestParameters: GetRoleRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<OrganizationRole> {
        const response = await this.getRoleRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Set the organization role of the given account
          */
    async setRoleRaw(requestParameters: SetRoleRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling setRole().'
            );
        }

        if (requestParameters['accountId'] == null) {
            throw new runtime.RequiredError(
                'accountId',
                'Required parameter "accountId" was null or undefined when calling setRole().'
            );
        }

        if (requestParameters['organizationRoleUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'organizationRoleUpdateRequest',
                'Required parameter "organizationRoleUpdateRequest" was null or undefined when calling setRole().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/client-settings/api/organizations/{organizationId}/member/{accountId}/role`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))).replace(`{${"accountId"}}`, encodeURIComponent(String(requestParameters['accountId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationRoleUpdateRequestToJSON(requestParameters['organizationRoleUpdateRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Set the organization role of the given account
          */
    async setRole(requestParameters: SetRoleRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.setRoleRaw(requestParameters, initOverrides);
    }

}
